// extracted by mini-css-extract-plugin
module.exports = {"label":"SecurityPage_label__2iR5P"};